import {useEffect, useState} from "react";
import useLocalStorageVO from "../components/Common/UseLocalStorageVO";
import {getSystemStatusBatch} from "../api/utilApi";

function useSystemStatusManager() {
    const { loginUser, isLogin } = useLocalStorageVO();

    const [userRoleGroup, setUserRoleGroup] = useState([{
        roleId: null,
        roleName: null,
        compCd: null,
        priorityLevel: null
    }]);
    const [userGroup, setUserGroup] = useState([{
        id: null,
        loginId: null,
        userName: null,
        departmentId: null,
        positionId: null,
        roleId: null,
        imagePath: null,
        userEmail: null,
        phoneNum: null,
        flagActive: null
    }]);
    const [siteGroup, setSiteGroup] = useState([{
        codeId: null,
        codeName: null
    }]);
    const [compCdGroup, setCompCdGroup] = useState([{
        compCd: null,
        companyName: null
    }]);

    useEffect(() => {
        if (isLogin()) { initialSetting(); }
    }, [loginUser])

    const initialSetting = async () => {
        try {
            const batchResult = await getSystemStatusBatch();

            if (batchResult) {
                // 배치 API 성공 시 모든 데이터 설정
                setCompCdGroup(batchResult.companies);
                setSiteGroup(batchResult.sites);
                setUserRoleGroup(batchResult.roles);
                setUserGroup(batchResult.users);
            }
        } catch (error) {
            console.warn('배치 API 실패, 개별 API로 폴백:', error);
        }
    }

    const commonData = async (list) => {
        return await list.filter(data => data?.compCd === 'default');
    }

    return { userRoleGroup, userGroup, siteGroup, compCdGroup, commonData };
}

export default useSystemStatusManager;